<div class="wrapper">
  <div class="titleContainer">
    <div class="title">
      {{'calendars.label.title' | translate }}
    </div>

    @if ((showCreateCustomCalendarButton$ | async)) {
      <button
        class="create-button" (click)="onAddCalendar()"
        >
        <div class="create-icon-container">
          <tun-plus-icon-v5 class="icon icon-create-button"></tun-plus-icon-v5>
        </div>
        {{'calendar.custom.create.title' | translate}}
      </button>
    }

  </div>


  @if ((calendarGroupsLoading$ | async)) {
    <div class="loaderContainer">
      <mat-spinner class="loading-spinner"></mat-spinner>
      <span class="loadingText">{{'general.status.loading' | translate}}</span>
    </div>
  }

  @if ((calendarGroupsLoadingError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }

  @if (!(calendarGroupsLoading$ | async) && !(calendarGroupsLoadingError$ | async)) {
    <div class="scrollContainer">
      <!-- custom calendars -->
      @if (showCustomCalendars$ | async) {
        <tun-calendar-group-view
          class="calendarGroup first"
          [groupName]="'calendars.user.label' | translate"
          [calendars]="customCalendars$ | async"
          [showAddButton]="true"
          (addCalendar)="onAddCalendar()"
          [lockOverlayMessage]="(accessToCustomCalendars$ | async) ?  null : ('accessRight.content.customCalendars' | translate)"
        ></tun-calendar-group-view>
      }
      <!-- calendarGroups -->
      @for (calendarGroup of (calendarGroups$ | async); track calendarGroup; let i = $index) {
        <tun-calendar-group-view
          class="calendarGroup {{ (!(showCustomCalendars$ | async) && i == 0)  ? 'first' : ''}}"
          [groupName]="calendarGroup.name"
          [calendars]="calendarGroup.calendars"
        ></tun-calendar-group-view>
      }
    </div>
  }
</div>
